module.exports = __webpack_public_path__ + "images/3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/slider/3.jpg
 ** module id = 647
 ** module chunks = 0
 **/